const apiRoute = 'https://eterpaz.rdox.ch';

export type ApiMemberType = {
  id: number;
  name: string;
  photo: string;
  translations: { languages_code: 'fr-FR'; introText: string; description?: string }[];
};

export type MemberType = {
  id: string;
  name: string;
  photoUrl: string;
  introText: string;
  description?: string;
};

export async function fetchMembers(): Promise<MemberType[]> {
  const res = await fetch(
    `${apiRoute}/items/TeamMembers?filter[status][_eq]=published&sort=sort&fields=*,translations.*`
  );
  return res.json();
}

/**
 * Convertit un texte Markdown simple en HTML et nettoie les échappements \"
 * Gère : **gras**, *italique*, et [texte](url) pour les liens, ainsi que les retours à la ligne.
 * @param markdownText Texte Markdown
 * @returns HTML prêt à passer dans dangerouslySetInnerHTML
 */
export function parseSimpleMarkdown(markdownText?: string) {
  if (!markdownText) return '';

  // 1. Nettoyer les échappements \"
  let text = markdownText.replace(/\\\\"/g, '"');

  // 2. Échapper les caractères HTML sensibles pour éviter l'injection
  text = text.replace(/</g, '&lt;').replace(/>/g, '&gt;');

  // 3. Convertir les liens : [texte](url) -> <a href="url" target="_blank" rel="noopener noreferrer">texte</a>
  text = text.replace(
    /\[([^\]]+)\]\(([^)]+)\)/g,
    '<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>'
  );

  // 4. Gras : **texte**
  text = text.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');

  // 5. Italique : *texte*
  text = text.replace(/\*(.+?)\*/g, '<em>$1</em>');

  // 6. Retours à la ligne : \n -> <br>
  text = text.replace(/\n/g, '<br>');

  return text;
}

export type DirectusFile = {
  id: string;
  title: string;
  description?: string;
  type?: string;
  tags?: string[];
  slug: string;
};

export type DirectusFileFk = {
  id: number;
  sort?: number;
  directus_files_id: DirectusFile;
};

// Objet reçu de l'API
export type CghApiType = {
  translations: ConditionsHebergementType[];
};

// Objet de travail
export interface ConditionsHebergementType {
  id: number;
  languages_code: { code: 'fr-FR' | 'de-DE' | 'en-GB' };
  A_title: string;
  A_description?: string;
  A_Conditions: DirectusFileFk[];
  B_title: string;
  B_description?: string;
  B1_NuitesMinimumParSejour: DirectusFile;
  C_title: string;
  C_description?: string;
  C1_ConditionDAnnulation: DirectusFile;
  D_title: string;
  D_description?: string;
  D_Nettoyages: DirectusFileFk[];
}

// Objet reçu de l'API
export type CgaApiType = {
  translations: ConditionsAnimationsType[];
};

// Objet de travail
export interface ConditionsAnimationsType {
  id: number;
  languages_code: { code: 'fr-FR' | 'de-DE' | 'en-GB' };
  E_title: string;
  E_description?: string;
  E_Packs: DirectusFileFk[];
  F_title: string;
  F_description?: string;
  F_Animations: DirectusFileFk[];
  G_title: string;
  G_description?: string;
  G_Location: DirectusFileFk[];
}

export function GetFilesPerTag(tag: string, files?: DirectusFile[]): DirectusFile[] {
  if (files && files.length > 0 && tag) {
    return files.filter((f) => f.tags?.includes(tag));
  }
  return [];
}

export const getUrlFromSlug = (slug: string, files?: DirectusFile[]) =>
  files?.find((file) => file.slug === slug);

// CAMP FLOORS

export type PlansColonieType = {
  campFloors: DirectusFile;
  campExterior: DirectusFile;
};

export type ApiFloorType = {
  id: number;
  slug: string;
  image: string;
  translations: {
    id: number;
    languages_code: string;
    name: string;
    description: string;
  }[];
};
